"use strict";
/** Error thrown when wrong acn, abn validation fails */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
class ValidationError extends Error {
    /** Class Constructor
     * @param message: String message that is sent to the user
     * @param this.name: "ValidationError"
     */
    constructor(message) {
        super(message);
        this.name = "ValidationError";
    }
}
exports.ValidationError = ValidationError;
//# sourceMappingURL=ValidationError.js.map